// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WSHR","image":"Header_image__2_DI8","name":"Header_name__2PNhK","info":"Header_info__3k2Qx","infoRow":"Header_infoRow__2WRte"};